/* global locale languages */
import DOMPurify from 'dompurify'
const host = () => window.location.host

const langStr = (lang) => lang.startsWith('en') ? '' : `/${lang}`

$(document)
  .on('turbo:load', function() {
    translatePaths()
    $('.language-menu .left-menu, .language-menu .right-menu').empty()
    let langs_list = []
    let href
    if (Object.keys(languages).length) {
      const leftMenu = $('.left-menu')
      const rightMenu = $('.right-menu')
      for (let i in languages) {
        let lang = languages[i]
        langs_list.push(lang.locale)
        if(lang.locale == 'en-GB'){
          href = `//${host()}${relativePath('/en', window.location)}`
        }else{
          href = `//${host()}${relativePath(`/${lang.locale}`, window.location)}`
        }

        if(window.brand_name == 'NBA Experiences') {
          if (parseInt(i) <= languages.length/2) {
            leftMenu.append(`<li class="menu-item navbar-item nav-item"> <a role="button" class="nav-link language ${lang.html_class}" onclick="window.location.href='${href}'"> <div class="navbar-item">${lang.display_name}</div></a> </li>`)
          }else {
            rightMenu.append(`<li class="menu-item navbar-item nav-item"> <a role="button" class="nav-link language ${lang.html_class}" onclick="window.location.href='${href}'"><div class="navbar-item">${lang.display_name}</div></a> </li>`)
          }
        } else {
          if (parseInt(i) <= languages.length/2) {
            leftMenu.append(`<li> <a role="button" class="language ${lang.html_class}" onclick="window.location.href='${href}'">${lang.display_name} </li>`)
          }else {
            rightMenu.append(`<li> <a role="button" class="language ${lang.html_class}" onclick="window.location.href='${href}'">${lang.display_name} </li>`)
          }
        }
      }

      let pathname = window.location.pathname
      let selectedLang = pathname.split('/')[1]
      
      // Safely read navigator.language (may be undefined in some environments)
      const hasNavigatorLanguage = typeof navigator !== 'undefined' && typeof navigator.language === 'string'
      const navigatorLang = hasNavigatorLanguage ? navigator.language : ''
      const navigatorPrimary = navigatorLang ? navigatorLang.split('-')[0].toLowerCase() : ''
      
      // Prepare a lowercased copy of langs_list for case-insensitive lookups
      const langsLower = langs_list.map((l) => l.toLowerCase())

      // If there is no language in the path, fall back to navigator.language with normalization
      if (!selectedLang) {
        let idx = navigatorLang ? langsLower.indexOf(navigatorLang.toLowerCase()) : -1
        if (idx === -1 && navigatorPrimary) {
          idx = langsLower.indexOf(navigatorPrimary)
        }
        selectedLang = idx !== -1 ? langs_list[idx] : 'en'
      } else if (!langs_list.includes(selectedLang)) {
        // If the path language is not directly supported, try matching its primary subtag
        const pathPrimary = selectedLang.split('-')[0].toLowerCase()
        const primaryIdx = langsLower.indexOf(pathPrimary)
        if (primaryIdx !== -1) {
          selectedLang = langs_list[primaryIdx]
        }
      }

      if(langs_list.includes(selectedLang)) {
        $('.language-label').text(selectedLang.substring(0,2))

        if(window.name == 'nba-exp') {
          if ($('.navbar-nav-left > .nav-item > .nav-link').width() > 150 )
            $('.navbar-nav-left > .nav-item > .nav-link').addClass('--long')
        }
      }
      else
        $('.language-label').text('en')
    }
  })

function translatePaths() {
  let anchors = $('a').filter('[href^="/"]')
  for (let anchor of Array.from(anchors)) {
    $(anchor).attr('href', relativePath(langStr(locale), anchor))
  }
}

function relativePath(locale, path) {
  const href = DOMPurify.sanitize(path.href.split(window.location.origin)[1])
  const currentLang = pathLang(path.pathname)
  const end = href.split(path.pathname)[1]
  const langRegex = new RegExp(`^/${currentLang}`)
  const pathname =  currentLang != '' ? path.pathname.split(langRegex)[1] : path.pathname
  return `${locale}${pathname}${end}`
}

function pathLang(path) {
  if (path == null) { path = window.location.pathname }
  const matches = pathMatch(path)
  return matches != null ? matches[1] : ''
}

function pathMatch(path) {
  return path.match(/^\/([a-z]{2}(-[A-Z]{2})?)(\/.*|$)/)
}
